import { createFileRoute } from '@tanstack/react-router'

import { PortfolioCalloutsScreen } from './-components/portfolio-callouts-screen.tsx'

export const Route = createFileRoute('/merchants/portfolio-callouts')({
  component: PortfolioCalloutsScreen
})
